import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { PanelActionGroup } from '@atlassian/panel-system/panel-action/group';

import type { PreviewPanelActionGroupProps } from './types';

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelActionGroup = ({
	children,
	testId,
}: PreviewPanelActionGroupProps): React.JSX.Element => {
	if (fg('ads-panel-system-gpp')) {
		return <PanelActionGroup testId={testId}>{children}</PanelActionGroup>;
	}

	return (
		<Inline testId={testId} space="space.050" alignBlock="center">
			{children}
		</Inline>
	);
};
